import { render, staticRenderFns } from "./interact.vue?vue&type=template&id=3c0ba60c&scoped=true&"
import script from "./interact.vue?vue&type=script&lang=js&"
export * from "./interact.vue?vue&type=script&lang=js&"
import style0 from "./interact.vue?vue&type=style&index=0&id=3c0ba60c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ba60c",
  null
  
)

export default component.exports